import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { Flex } from './index.js';
import useRelayClient from '../../hooks/useRelayClient.js';
import { isDarkMode } from '../../utils/theme.js';
const ChainIcon = ({ chainId, css = {}, height = 14, width = 14, square = true }) => {
    const client = useRelayClient();
    const chain = chainId
        ? client?.chains?.find((chain) => chain.id === chainId)
        : null;
    const icon = chain
        ? isDarkMode()
            ? chain.icon?.dark || chain.icon?.light
            : chain.icon?.light
        : null;
    const iconUrl = square && icon ? icon.replace('/icons/', '/icons/square/') : icon;
    return iconUrl ? (_jsx(Flex, { css: {
            display: 'flex',
            flexShrink: 0,
            ...css
        }, style: {
            height: height,
            width: width
        }, children: iconUrl ? (_jsx("img", { src: iconUrl, alt: `Chain #${chainId}`, style: {
                borderRadius: square ? 4 : 0,
                width: css && css.width ? Number(css.width) : '100%',
                height: css && css.height ? Number(css.height) : '100%'
            } })) : null })) : null;
};
export default ChainIcon;
//# sourceMappingURL=ChainIcon.js.map